import React from 'react';
import {Text, Card, TextPriority} from 'wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './PickupInfoBox.st.css';
import {useControllerProps} from '../Widget/ControllerContext';
import {StepId} from '../../../types/checkoutApp.types';

export enum PickupInfoBoxDataHook {
  root = 'PickupInfoBox.root',
  deliveryTimeDetails = 'PickupInfoBox.deliveryTimeDetails',
  instructionsTitle = 'PickupInfoBox.instructionsTitle',
  instructionsDetails = 'PickupInfoBox.instructionsDetails',
}

export interface PickupInfoBoxProps {
  instructions?: string;
  deliveryTime?: string;
  insideTimeSelector?: boolean;
}

const PickupInfoBoxInternal = ({insideTimeSelector, instructions, deliveryTime}: PickupInfoBoxProps) => {
  const localeKeys = useLocaleKeys();
  const {
    stepsManagerStore: {activeStep},
  } = useControllerProps();
  const shouldShowDeliveryTime = deliveryTime && activeStep.stepId === StepId.deliveryMethod;

  return instructions ? (
    <div className={insideTimeSelector ? classes.insideTimeSelector : classes.root}>
      <Card data-hook={PickupInfoBoxDataHook.root} className={classes.card}>
        <Card.Container>
          {shouldShowDeliveryTime && (
            <Text
              data-hook={PickupInfoBoxDataHook.deliveryTimeDetails}
              priority={TextPriority.secondary}
              className={classes.deliveryTime}>
              {deliveryTime}
            </Text>
          )}
          <Text
            tagName={'h4'}
            data-hook={PickupInfoBoxDataHook.instructionsTitle}
            priority={TextPriority.primary}
            className={classes.title}>
            {localeKeys.checkout.pickup_details_form.store_pickup_instructions_header()}
          </Text>
          <Text
            data-hook={PickupInfoBoxDataHook.instructionsDetails}
            priority={TextPriority.secondary}
            className={classes.instructions}>
            {instructions}
          </Text>
        </Card.Container>
      </Card>
    </div>
  ) : null;
};

export const PickupInfoBox = React.memo(PickupInfoBoxInternal);
